module.exports = __webpack_public_path__ + "img/downloadNowen.714f996b.png";